export default __webpack_public_path__ + "798271153b44e2324af20c9050c9bcdb.svg";